import { render, staticRenderFns } from "./YearsMoney.vue?vue&type=template&id=465efac3&"
import script from "./YearsMoney.vue?vue&type=script&lang=js&"
export * from "./YearsMoney.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports